import React, {useState, useEffect} from 'react';
import { useTranslation, Trans } from 'react-i18next'
import Customize from './Customize'
import custom from './esigncustom.json'

const constants = require('./constants');

const Home = props => {
  const [count, setCount] = useState(0);
  const [customTexts, setCustomTexts] = useState(custom);
  const { i18n, t } = useTranslation();

  const parentEventSend = props.parentEventCb;
  const checkFetchRespSession = (resp)=> {
    if (!resp.ok) {
      if(resp.status === 401) {
        parentEventSend("SESSION_EXPIRED");
      }
      throw Error(resp.statusText);
    }
    return resp;
  }
  useEffect(() => {
    fetch(constants.SERVER_URL + "/api/pendingcount",{method:'get'})
      .then(resp => checkFetchRespSession(resp))
      .then(resp =>resp.json())
      .then(data => setCount(data.count))
      .catch(error => {
        console.log("Fetching signeddocs error:", error)
      }
      );
  });

  useEffect(() => {
    fetch(Customize.CustomTextsPath(), { method: "get" })
      // .then(resp => checkFetchRespSession(resp))
      .then(response => response.json())
      .then(data => setCustomTexts(data))
      .catch(error => {
        console.log("Fetching customtexts error:",)
      });
  }, [])

  const renderHeaderText = () => {
    if (i18n.language === "en") {
      return (
        customTexts.customHeaderTextEN
      );
    }
    else if (i18n.language === "fi") {
      return (
        customTexts.customHeaderTextFI
      );
    }
    else {
      return (
        customTexts.customHeaderTextSE
      );
    }
  }

  const renderCustomTexts = () => {
    if (i18n.language === "en") {
      return (
        <div>
          <p>{customTexts.customText1EN}</p>
          <p>{customTexts.customText2EN}</p>
        </div>
      );
    }
    else if (i18n.language === "fi") {
      return (
        <div>
          <p>{customTexts.customText1FI}</p>
          <p>{customTexts.customText2FI}</p>
        </div>
      );
    }
    else {
      return (
        <div>
          <p>{customTexts.customText1SE}</p>
          <p>{customTexts.customText2SE}</p>
        </div>
      );
    }
  }

  return (
    <div>
      <Customize.Style />
      <p><br></br> </p>
      <div className='homeContent'>
        <Customize.MainLogo />
        <div className='homeTexts'>
          <h1>{renderHeaderText()}</h1>
          <br/>
          <h3>
            <Trans i18nKey="You have new documents to sign" count={count}>
              You have <a href={constants.SERVER_CONTEXT_PATH+"/Pending"}>{{count}} new documents</a> to sign
            </Trans>
          </h3>
          <br/>
          {renderCustomTexts()}
          <div>
            <br/>
            <p>{t("Cookies in use info")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default (Home);